import React, { useState } from 'react'
import Avtar from '../../Images/avatar.png'


function ViewUser({ showViewModal, setShowViewModal, selectedUser }) {

    const [open, setOpen] = useState(showViewModal);

    const closeViewModal = () => {
        setOpen(false)
        setShowViewModal(false)
    }

    console.log("User dtata", selectedUser)

    function formatToDateTimeLocal(dateString) {
    if(dateString === null){
        return null
    }
  const date = new Date(dateString); // UTC date
  const tzOffset = date.getTimezoneOffset() * 60000; // offset in milliseconds
  const localDate = new Date(date.getTime() - tzOffset); // convert to local time
  return localDate.toISOString().slice(0, 16); // format to "YYYY-MM-DDTHH:MM"
}

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white  rounded-lg shadow-lg w-[900px] h-[600px] overflow-y-auto">
                <h3 className="text-xl font-bold mb-1 text-center bg-gradient-to-br from-blue-950 to-blue-500 py-2 text-white">
                   View User Details
                </h3>
                <form className="p-8 bg-purple-200">

                    <div className="flex gap-2 ">
                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">First Name</label>
                            <input
                                type="text"
                                name="firstName"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedUser.firstName}
                                disabled
                            />
                        </div>
                        <div className="w-full mt-2">
                            <label className="block mb-1 font-bold">Last Name</label>
                            <input
                                type="text"
                                name="lastName"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedUser.lastName}
                                disabled
                            />
                        </div>
                    </div>

                    <div className="w-full mt-4">
                        <label className="block mb-1 font-bold">Email</label>
                        <input
                            type="text"
                            name="email"
                            className="border border-gray-800 p-2 w-full"

                            value={selectedUser.email}
                            disabled
                        />
                    </div>
                    <div className="flex gap-2 ">
                        <div className="w-full mt-4">
                            <label className="block mb-1 font-bold">Phone</label>
                            <input
                                type="text"
                                name="phone"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedUser.phone}
                                disabled
                            />
                        </div>
                        <div className="w-full mt-4">
                            <label className="block mb-1 font-bold">Status</label>
                            <input
                                type="text"
                                name="active"
                                className={`border border-gray-800 ${selectedUser.active ? 'bg-green-300' : 'bg-red-300'} p-2 w-full`}

                                value={selectedUser.active ? 'Active' : 'Inactive'}
                                disabled
                            />
                        </div>
                    </div>

                    <div className="flex gap-2 ">
<div className="w-full mt-4">
                            <label className="block mb-1 font-bold">Subscription Plan</label>
                            <input
                                type="text"
                                name="subscriptionPlan"
                                className="border border-gray-800 p-2 w-full"

                                value={selectedUser.subscriptionPlan}
                                disabled
                            />
                        </div>

                        {selectedUser.adminUpdatedPlan === true ? (
                        <div className="w-full mt-4">
                            <label className="block mb-1 font-bold">Subscription Expire</label>
                            <input
                            type="datetime-local"
                            name="expirationDate"
                            className="border border-gray-800 p-2 w-full "
                           
                            value={formatToDateTimeLocal(selectedUser.adminUpgradeExpiresAt)}
                            
                            disabled
                        />
                        </div>
                        ) : (
                             <div className="w-full mt-4">
                                </div>
                        )}
                        
                    </div>

                    <div className="w-full mt-4">
                        <label className='block mb-1 font-bold'>Profile Picture</label>
                        <img
                        src={selectedUser?.profileImageUrl || Avtar}
                        alt='Profile Pic'
                        className='h-32 w-32 object-cover rounded-full'
                        >
                        </img>
                    </div>

                    <div className="flex justify-end gap-6 mt-6">
                        <button onClick={closeViewModal} className="bg-gray-300 border border-gray-800 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200">
                            Close
                        </button>


                    </div>

                </form>
            </div>
        </div>
    )
}

export default ViewUser